<template>
  <section class='content-section quote'>
    <div class="quote__inner">
      <div class="quote__inner--client client">
        <div class="quote__inner--client--img client--img"><prismic-image :field="slice.primary.portrait_author"/></div>
        <div class="quote__inner--client--name client--name">{{ $prismic.richTextAsPlain(slice.primary.name_of_the_author) }}</div>
      </div>
      <blockquote class="block-quotation quote__inner--quotation">{{ $prismic.richTextAsPlain(slice.primary.quote) }}</blockquote>

    </div>


  </section>
</template>

<script>
export default {
  props: ['slice'],
  name: 'quote'
}
</script>

<style lang="scss">
  .quote {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background: #ccc;
    padding-top: 25px;
    &__inner {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 1% 10%;
      @media (max-width: 767px) {
        flex-direction: column;
        padding: 1% 0;
      }
      &--quotation {
        display: flex;
        font-family: 'Lora', Serif;
        font-size: 20px;
        font-style: italic;
        font-weight: normal;
        color: #484D52;
        letter-spacing : 1.14;
        line-height: 1.5em;
        quotes: "\201C""\201D""\2018""\2019";
        text-align: center;
        flex-basis: 70%;
      }
      &--client {
        display: flex;
        flex-basis: 20%;
        flex-direction: column;
        align-items: center;
        &--img {
          display: flex;
          width: 150px;
          height: 150px;
          border: 3px solid #fff;
          box-shadow: -5px 3px 15px #c5c5c5;
          border-radius: 50%;
          padding: 0;
          overflow: hidden;
          margin-bottom: 20px;
          & img {
              width: 150px;
          }
        }
        &--name {
          font-size: 13px;
          font-weight: 500;
          padding-bottom: 5px;
          position: relative;
          &::after {
              content: "";
              left: 20%;
              width: 60%;
              position: absolute;
              height: 2px;
              background: #e9e9e9;
              bottom: 0;
              right: 0;

          }
        }
      }
    }
  }

  .project-client-img {
    display: flex;
    max-width: 150px;
    height: 150px;
    border: 3px solid #fff;
    box-shadow: -5px 3px 15px #c5c5c5;
    border-radius: 50%;
    padding: 0;
    overflow: hidden;
  }
  blockquote {
    display: flex;
    font-family: 'Lora', Serif;
    font-size: 30px;
    font-style: italic;
    font-weight: normal;
    color: #484D52;
    letter-spacing : 1.14;
    line-height: 1.5em;
    quotes: "\201C""\201D""\2018""\2019";
    text-align: center;
    flex-basis: 70%;
  }
  blockquote:before,
  blockquote:after {
    color: #e9e9e9;
    content: open-quote;
    font-family: 'Lora', Serif;
    font-size: 2.5em;
    font-weight: 900;
    line-height: 0.1em;
    margin-left: 10px;
    margin-right: 10px;
    vertical-align: -0.3em;
  }
  blockquote:after {
    content: close-quote;
  }
  .project-client-name {
    display: flex;

  }

/* Media Queries */
@media (max-width: 767px) {
  .quote {
    font-size: 20px;
  }
}
</style>
